import { css } from 'lit-element'
export default css`
  .tailwind .btn-primary {
    height: 50px;
    width: 100%;
    --tw-bg-opacity: 1;
    background-color: rgb(253 189 76 / var(--tw-bg-opacity));
    font-size: 1.125rem;
    line-height: 1.75rem;
    --tw-text-opacity: 1;
    color: rgb(35 31 32 / var(--tw-text-opacity));
    cursor: pointer;
    border-style: none;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
    transition: background-color 0.3s ease-in-out;
  }
  @media (hover: hover) {
    .tailwind .btn-primary:hover {
      --tw-bg-opacity: 1;
      background-color: rgb(35 31 32 / var(--tw-bg-opacity));
      --tw-text-opacity: 1;
      color: rgb(255 255 255 / var(--tw-text-opacity));
    }
  }
`
